import { render, staticRenderFns } from "./TestingApprovalSettings.vue?vue&type=template&id=0cc6d9d4"
import script from "./TestingApprovalSettings.vue?vue&type=script&lang=ts"
export * from "./TestingApprovalSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports